import * as React from 'react';

import { DotIndicator } from 'components/base/indicator';
import { DOT_INDICATOR_COUNT, DOT_INDICATOR_SIZE } from 'theme/sizes';
import { Bold, Regular } from 'theme/text';
import { Colors } from 'theme/colors';
import { FontSize } from 'theme/fonts';
import { formatCurrency } from 'utils/helpers';

import { HeaderContainer } from '../styles';

/**
 * A modal header for showing the price to the user.
 *
 * @param props - Render props
 */
export function ModalHeader(props: Props) {
  const { premium, loading } = props;

  return (
    <HeaderContainer>
      {loading ? (
        <DotIndicator color={Colors.alto} count={DOT_INDICATOR_COUNT} size={DOT_INDICATOR_SIZE} />
      ) : (
        <Regular color={Colors.white} fontSize={FontSize.H4}>
          Your Price |{' '}
          <Bold color={Colors.white} fontSize={FontSize.H4}>
            {formatCurrency(premium)}pm
          </Bold>
        </Regular>
      )}
    </HeaderContainer>
  );
}
/* Type definitions */
interface Props {
  /** Controls the loading state when a recalculation takes place  */
  loading?: boolean;
  /** Premium per period  */
  premium: number;
}
